import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IEditSurveyFormResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

// Fetch single survey form
export const fetchEditSurveyForm = createServiceAsyncThunk<
  IEditSurveyFormResponse,
  number
>(
  ACTION_NAMES.EDIT_SURVEY_FORM,
  (id) => surveyFormsService.getSurveyFormById(id),
  ERROR_MESSAGES.EDIT_SURVEY_FORM_FAILURE
);

// Slice
const editSurveyFormSlice = createGenericSlice<IEditSurveyFormResponse, number>(
  SLICE_NAMES.EDIT_SURVEY_FORM_SLICE,
  fetchEditSurveyForm
);

export const {
  clearError: clearEditSurveyFormError,
  clearSuccessMessage: clearEditSurveyFormSuccessMessage,
} = editSurveyFormSlice.actions;

export default editSurveyFormSlice.reducer;
